import Tooltip from '../../node_modules/bootstrap/js/dist/tooltip'

export function tooltipable(node) {
  const tooltip = new Tooltip(node)
  node.addEventListener('click', () => {
    tooltip.hide()
  })

  return {
    destroy() {
      tooltip.dispose()
    },
  }
}
